import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import Navbar from "../components/Navbar";
import { useLanguage } from "../contexts/LanguageContext";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Blog = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { lang } = useLanguage();

  useEffect(() => {
    axios.get(`${API_URL}/api/articles?limit=20`)
      .then(r => setArticles(r.data.articles || []))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Helmet>
        <title>Blog Santé Algérie | Tabbibak.com</title>
        <meta name="description" content="Conseils médicaux, santé en Algérie, trouver un médecin. Articles rédigés par des experts pour les patients algériens." />
      </Helmet>
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-[#0F172A] mb-2">Blog Santé</h1>
        <p className="text-[#64748B] mb-8">Conseils médicaux et santé en Algérie</p>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="animate-spin w-10 h-10 border-4 border-[#0596DE] border-t-transparent rounded-full" />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map(article => (
              <Link key={article.article_id} to={`/blog/${article.slug}`}
                className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow overflow-hidden border border-[#E2E8F0]">
                {article.cover_url ? (
                  <img src={article.cover_url} alt={article.title} className="w-full h-40 object-cover" />
                ) : (
                  <div className="w-full h-40 bg-gradient-to-br from-[#0596DE] to-[#0369A1] flex items-center justify-center">
                    <span className="text-white text-4xl">🏥</span>
                  </div>
                )}
                <div className="p-4">
                  <h2 className="font-semibold text-[#0F172A] text-base mb-2 line-clamp-2">
                    {lang === "ar" && article.title_ar ? article.title_ar : article.title}
                  </h2>
                  <p className="text-[#64748B] text-sm line-clamp-2">
                    {lang === "ar" && article.excerpt_ar ? article.excerpt_ar : article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center justify-between text-xs text-[#94A3B8]">
                    <span>{article.clinic_name || "Tabbibak.com"}</span>
                    <span>{new Date(article.created_at).toLocaleDateString("fr-DZ")}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
